import { render, staticRenderFns } from "./AcademiesSelect.vue?vue&type=template&id=56c96f16&scoped=true"
import script from "./AcademiesSelect.vue?vue&type=script&lang=js"
export * from "./AcademiesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c96f16",
  null
  
)

export default component.exports